// src/pages/dashboard/components/ScheduledTaskLists.js
import React, { useState, useEffect } from 'react';

const ScheduledTaskLists = () => {
  const [taskLists, setTaskLists] = useState([]);

  useEffect(() => {
    // Simulate API call to fetch scheduled task lists
    const fetchTaskLists = async () => {
      const response = await fetch('/api/scheduled-tasklists'); // Replace with real API endpoint
      const data = await response.json();
      setTaskLists(data);
    };

    fetchTaskLists();
  }, []);

  return (
    <div>
      <h3>Scheduled Task Lists</h3>
      <ul>
        {taskLists.map((task) => (
          <li key={task.Id}>
            Task ID: {task.Id}, Status: {task.Status}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ScheduledTaskLists;
